module.exports = __webpack_public_path__ + "static/20-1701f476a1986247ffc4b7b24c1098e5.jpg";